import { Alert, Box, Button, Checkbox, FormControl, FormControlLabel, Grid, InputLabel, Link, MenuItem, Select, TextField } from "@mui/material";
import { Backend } from "../services/Backend";
import { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { SuccessToast } from "../utils/utils";
import ReCAPTCHA from "react-google-recaptcha";
import { CheckBox } from "@mui/icons-material";
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    zipcode: Yup.string().required('Zip code is required'),
    country: Yup.string().required('Country is required'),
    state: Yup.string().required('State is required'),
    address: Yup.string().required('Address is required'),
    functionTitle: Yup.string().required('Function is required'),
    dateOfBirth: Yup.date().required('Date of birth is required'),
    companyName: Yup.string().required('Company name is required'),
    language: Yup.string().required('Language is required'),
    interest: Yup.string().required('Interest is required'),
    password: Yup.string().min(8, 'Password must be at least 8 characters').required('Password is required'),
    email: Yup.string().email('Invalid email address').required('Email address is required'),
    lastName: Yup.string().required('Last name is required'),
    firstName: Yup.string().required('First name is required'),
});

export function RegisterPage() {
    const [error, setError] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [interest, setInterest] = useState("");
    const [language, setLanguage] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [functionTitle, setFunctionTitle] = useState("");
    const [address, setAddress] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [agree, setAgree] = useState(false);

    const validateForm = async () => {
        try {
            await validationSchema.validate({
                firstName,
                lastName,
                email,
                password,
                interest,
                language,
                companyName,
                dateOfBirth,
                functionTitle,
                address,
                state,
                country,
                zipcode,
            });
            setError("");
            return true;
        } catch (err) {
            console.dir(err.message);
            setError(err.message);
            return false;
        }
    }

    const onRegister = async () => {
        if (!await validateForm()) return;

        const body = {
            firstName,
            lastName,
            email,
            password,
            interest,
            language,
            companyName,
            dateOfBirth,
            function: functionTitle,
            address,
            state,
            country,
            zipcode,
        };

        Backend.post("auth/register", body)
            .then(res => {
                SuccessToast("Success");
                setTimeout(() => window.location.href = '/signin', 1000);
            })
            .catch(err => setError(err));
    }

    return <>
        <div className="w-[400px] mx-[auto] mt-[150px] mb-[50px]">
            <h1 className="text-4xl text-center mb-[50px]">Register</h1>
            {error && <Alert severity="error">{error}</Alert> }
            <Box component="form" sx={{ mt: 1 }}>
                <TextField margin="normal" required fullWidth label="First name" value={firstName} onChange={(e) => setFirstName(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Last name" value={lastName} onChange={(e) => setLastName(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} /> 
                
                <FormControl fullWidth  margin="normal">
                    <InputLabel>Interest</InputLabel>
                    <Select
                        label="Interest"
                        margin="normal"
                        value={interest}
                        onChange={(e) => setInterest(e.target.value)}
                    >
                        <MenuItem value="Transport safety">Transport safety</MenuItem>
                        <MenuItem value="Industrial safety">Industrial safety</MenuItem>
                        <MenuItem value="Chemical warehousing">Chemical warehousing</MenuItem>
                        <MenuItem value="Tank storage">Tank storage</MenuItem>
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <InputLabel>Language</InputLabel>
                    <Select
                        label="Language"
                        margin="normal"
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                    >
                        <MenuItem value="English">English</MenuItem>
                        <MenuItem value="Dutch">Dutch</MenuItem>
                        <MenuItem value="German">German</MenuItem>
                        <MenuItem value="Spanish">Spanish</MenuItem>
                        <MenuItem value="French">French</MenuItem>
                        <MenuItem value="Chinese">Chinese</MenuItem>
                    </Select>
                </FormControl>

                <TextField margin="normal" required fullWidth label="Company name" className="mb-[20px]" value={companyName} onChange={(e) => setCompanyName(e.target.value)} /> 
                <DatePicker sx={{ mt: 2, mb: 1 }}  slotProps={{ textField: { fullWidth: true } }} margin="normal" required fullWidth label="Date of birth" value={dateOfBirth} onChange={(date) => setDateOfBirth(date)} /> 
                <TextField margin="normal" required fullWidth label="Function" value={functionTitle} onChange={(e) => setFunctionTitle(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Address" value={address} onChange={(e) => setAddress(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="State" value={state} onChange={(e) => setState(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Country" value={country} onChange={(e) => setCountry(e.target.value)} /> 
                <TextField margin="normal" required fullWidth label="Zip code" value={zipcode} onChange={(e) => setZipcode(e.target.value)} /> 
                <FormControlLabel control={<Checkbox value={agree} onChange={(e) => setAgree(e.target.checked)} />} label={<p className="text-sm">I agree with the <a href="/conditions" target="_blank" className="text-blue-500 hover:underline hover:text-blue-600">terms and conditions</a></p>} />
                <ReCAPTCHA
                    sitekey="6LdvR38qAAAAAC9NM0fx2EjlcXFh6ce70kBRjIUr"
                    onChange={(e) => { console.log(e) }}
                />
                <Button
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    onClick={onRegister}
                    disabled={!agree}
                >
                Sign up
                </Button>
                <Link href="/signin" variant="body2">Already have an account? Sign In</Link>
            </Box>
        </div>
    </>
}